const callAPIHandler = (apiClient, api, version, fullName, args) => {
    const result = apiClient[api][version][fullName](args);
    return result.then(response => response, reject => reject)
        .catch(error => error);
};

export default callAPIHandler;
